export function chunkStringIntoFours(input: string) {
  if (typeof input !== 'string') {
    throw Error('chunkStringIntoFours can only chunk strings');
  }
  if (/[\uD800-\uDBFF]/.test(input)) {
    throw Error('chunkStringIntoFours does not support non BMP strings');
  }
  if (/[\s]/.test(input)) {
    throw Error('chunkStringIntoFours does not support whitespace');
  }
  return input.match(/.{1,4}/g)?.join(' ') ?? '';
}
